<script lang="ts" setup>
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import { EMPLOYEES_LIST_ROUTE_NAME } from '@modules/employees/constants';
import { TRANSLATION_GROUP_EMPLOYEES_EDIT } from '@modules/employees/submodules/edit/constants';
import { useEmployeeEditPage } from '@modules/employees/submodules/edit/pages/EmployeeEditPage/composables';
import VForm from '@modules/forms/components/VForm/VForm.vue';

const {
  isLoadingQuery,
  isSaveLoading,
  formSchema,
  formGroups,
  errors,
  clearError,
  handleSubmit,
} = useEmployeeEditPage();
</script>

<template>
  <VCard v-data-qa-auto-id="'EmployeeEditPage'"
    :title="$getTranslation(TRANSLATION_GROUP_EMPLOYEES_EDIT, 'MAIN_TITLE')"
    type="form"
  >
    <VLoader
      :loading="isLoadingQuery"
      mode="overlay"
    >
      <VForm
        :schema="formSchema"
        :groups="formGroups"
        :submit-btn-label="$getTranslation(TRANSLATION_GROUP_EMPLOYEES_EDIT, 'SAVE')"
        :custom-errors="errors"
        :is-loading="isSaveLoading"
        @submit="handleSubmit"
        @interacted="clearError"
      >
        <template #secondaryBtn>
          <VBackButton
            :label="$getTranslation(TRANSLATION_GROUP_EMPLOYEES_EDIT, 'BACK')"
            :to="{ name: EMPLOYEES_LIST_ROUTE_NAME }"
          />
        </template>
      </VForm>
    </VLoader>
  </VCard>
</template>
